/**
 * Inicializa Slick en las galerías del bloque (jQuery + slick ya cargados por el plugin).
 */
function getJsonAttr( $el, attrName ) {
	const raw = $el.attr( attrName );
	if ( ! raw ) {
		return {};
	}
	try {
		return JSON.parse( raw );
	} catch {
		return {};
	}
}

function pauseAllVideos( $scope ) {
	$scope.find( 'video' ).each( function eachVideo() {
		try {
			this.pause();
		} catch {
			// noop
		}
	} );
}

function playActiveVideo( $slider, index ) {
	const $current = $slider.find( '.slick-slide[data-slick-index="' + index + '"]' );
	const videoEl = $current.find( 'video' ).get( 0 );
	if ( ! videoEl ) {
		return;
	}
	videoEl.muted = true;
	videoEl.playsInline = true;
	const playResult = videoEl.play();
	if ( playResult && typeof playResult.catch === 'function' ) {
		playResult.catch( () => {} );
	}
}

function initMetaGallerySliders() {
	const $ = window.jQuery;
	if ( ! $ || ! $.fn || ! $.fn.slick ) {
		window.requestAnimationFrame( initMetaGallerySliders );
		return;
	}

	$( '.cvip-meta-gallery' ).each( function initOne() {
		const $gallery = $( this );
		const $main = $gallery.find(
			'.cvip-meta-gallery-slider[data-cvip-meta-gallery="1"]'
		);
		if ( ! $main.length || $main.hasClass( 'slick-initialized' ) ) {
			return;
		}
		const $thumbs = $gallery.find(
			'.cvip-meta-gallery-thumbs[data-cvip-meta-gallery-thumbs="1"]'
		);
		const thumbsArtificial =
			$thumbs.length &&
			$thumbs.attr( 'data-cvip-thumbs-artificial' ) === '1';
		const mainOpts = getJsonAttr( $main, 'data-slick-options' );
		const thumbsOpts = $thumbs.length
			? getJsonAttr( $thumbs, 'data-slick-options' )
			: {};

		if ( $thumbs.length && ! $thumbs.hasClass( 'slick-initialized' ) ) {
			$thumbs.slick( {
				slidesToShow: 6,
				slidesToScroll: 1,
				arrows: false,
				dots: false,
				focusOnSelect: true,
				...thumbsOpts,
			} );

			if ( thumbsArtificial ) {
				$thumbs.on(
					'click',
					'.cvip-meta-gallery-thumbs__slide',
					function onThumbClick() {
						const target = parseInt(
							$( this ).attr( 'data-cvip-thumb-target' ) || '0',
							10
						);
						if ( Number.isFinite( target ) ) {
							$main.slick( 'slickGoTo', target, true );
						}
					}
				);
			}
		}

		$main.slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: true,
			adaptiveHeight: true,
			...mainOpts,
		} );

		const autoplayVideos = $main.attr( 'data-autoplay-videos' ) === '1';
		if ( autoplayVideos ) {
			const syncVideo = ( nextIndex ) => {
				pauseAllVideos( $main );
				playActiveVideo( $main, nextIndex );
			};
			$main.on( 'init', function onInit( event, slick ) {
				syncVideo( slick.currentSlide || 0 );
			} );
			$main.on( 'afterChange', function afterChange( event, slick, current ) {
				syncVideo( current );
			} );
			const initial = $main.slick( 'slickCurrentSlide' );
			syncVideo( typeof initial === 'number' ? initial : 0 );
		}

		if ( $thumbs.length && thumbsArtificial ) {
			const syncThumbPosition = ( current ) => {
				const $match = $thumbs.find(
					'.slick-slide:not(.slick-cloned)[data-cvip-thumb-target="' +
						current +
						'"]'
				);
				const slickIndex = parseInt( $match.attr( 'data-slick-index' ), 10 );
				if ( Number.isFinite( slickIndex ) ) {
					$thumbs.slick( 'slickGoTo', slickIndex, true );
				}
			};
			$main.on( 'afterChange', function afterChange( event, slick, current ) {
				syncThumbPosition( current );
			} );
			const initial = $main.slick( 'slickCurrentSlide' );
			syncThumbPosition( typeof initial === 'number' ? initial : 0 );
		}
	} );
}

function boot() {
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initMetaGallerySliders );
	} else {
		initMetaGallerySliders();
	}
}

boot();
